import { ReactComponent as CursosIcon } from "../../assets/img/icons/cursos.svg";
import { ReactComponent as AlunosIcon } from "../../assets/img/icons/alunos.svg";
import { useContext, useEffect, useState } from "react";
import { useHomeInfoApi, useUserApi, useTagApi, useLogin } from "../../Hooks";
import { storageUrl, region } from "../../Configs";
import PageWithSidebar from "../PageWithSidebar";
import { UserInfoContext } from "../../Contexts/UserInfoContext";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import TeacherAreaModal from "./TeacherAreaModal";
import {getLocalizedRoutePath, ROUTE_KEYS} from "../../routes/definitions";
import { APP_VERSION } from "../../config/appVersion";

export default function Home() {
    const [loading, setLoading] = useState(true);
    const [homeInfo, setHomeInfo] = useState({ description: '' });
    const homeInfoApi = useHomeInfoApi();
    const [userInfo, setUserInfo] = useContext(UserInfoContext);
    const userIsAdmin = userInfo.role === "Admin" || userInfo.role === "PlaymoveAdmin";
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const userAPi = useUserApi();
    const tagApi = useTagApi();
    const { getRoleFromToken } = useLogin();

    const [areaOptions, setAreaOptions] = useState([]);
    const [loadingAreas, setLoadingAreas] = useState(false);

    const region = process.env.REACT_APP_REGION;
    const isBrazilRegion = region == "BR";
    const isMasterTag = (tag) => {
        const name = (tag?.name ?? tag?.Name ?? "").toString().trim().toLowerCase();
        return name === "curso master";
    };

    useEffect(() => {
        async function fetchData() {
            if (isOpen) {
                setLoadingAreas(true);
                const data = await tagApi.tagsList();
                const filtered = Array.isArray(data) ? data.filter((tag) => !isMasterTag(tag)) : [];
                setAreaOptions(filtered);
                setLoadingAreas(false)
            }
        }
        fetchData();
    }, [isOpen]);

    useEffect(() => {
        const shouldOpen =
            userInfo.name &&
            userInfo.role !== "Admin" &&
            userInfo.role !== "PlaymoveAdmin" &&
            isBrazilRegion &&
            Boolean(userInfo.isFirstAccess);

        setIsOpen(shouldOpen);
    }, [userInfo]);

    const paragraphs = homeInfo.description.split('\n').filter((paragraph) => paragraph.trim() !== '');

    useEffect(() => {
        setLoading(true);
        const loadData = async () => {
            await new Promise((r) => setTimeout(r, 300));
            const languageId = localStorage.getItem("languageId");
            const getHomeInfo = await homeInfoApi.homeInfo(languageId);
            if (getHomeInfo) {
                setHomeInfo(getHomeInfo);
                setLoading(false);
            }
        };
        loadData();
    }, []);

    const handleSaveTeacherArea = async (selectedAreas) => {
        try {
            setLoading(true);
            await userAPi.setUserArea(selectedAreas);
            setLoading(false);
            setIsOpen(false);
        } catch (e) {
            setLoading(false);
        }
    };

    const [language, setLanguage] = useState(localStorage.getItem("language") || "pt-BR");

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [i18n, language]);

    const coursesPath = getLocalizedRoutePath(ROUTE_KEYS.COURSES, language);
    const registrationsPath = getLocalizedRoutePath(ROUTE_KEYS.REGISTRATIONS_HOME, language);

    return (
        <PageWithSidebar loading={loading}>
            <TeacherAreaModal
                isOpen={isOpen}
                onConfirm={handleSaveTeacherArea}
                options={areaOptions}
                loadingOptions={loadingAreas}
                language={language}
            />

            {homeInfo && (
                <div className="flex flex-col gap-y-10 md:flex-row md:gap-x-10 items-center">
                    {/* COLUNA DA IMAGEM COM OVERLAY */}
                    <div className="relative w-full md:w-1/2 h-[400px] md:h-[85vh] bg-cover bg-center rounded-xl overflow-hidden"
                        style={{ backgroundImage: `url('${storageUrl}/${homeInfo.imagePath}')` }}>
                    </div>

                    {/* COLUNA DO TEXTO + BOTÕES */}
                    <div className="w-full md:w-1/2">
                        <b className="text-2xl font-dosisbold">{homeInfo.title}</b>
                        {paragraphs.map((paragraph, index) => (
                            <p className="mt-3 text text-lg font-inter" key={index}>
                                {paragraph}
                            </p>
                        ))}

                        {/* BOTÕES */}
                        <div className="mt-8 flex flex-col md:flex-row gap-4">
                            <Link to={coursesPath} className="border rounded-lg p-4 shadow hover:bg-gray-100 flex-1">
                                <div className="flex items-center gap-x-2">
                                    <CursosIcon className="stroke-black h-8" />
                                    <div>
                                        <b>{t("courses")}</b>
                                        <p>{t("coursesDescription")}</p>
                                    </div>
                                </div>
                            </Link>

                            {userIsAdmin && (
                                <Link to={registrationsPath} className="border rounded-lg p-4 shadow hover:bg-gray-100 flex-1">
                                    <div className="flex items-center gap-x-2">
                                        <AlunosIcon className="fill-black h-8" />
                                        <div>
                                            <b>{t("registrations")}</b>
                                            <p>{t("registrationsDescription")}</p>
                                        </div>
                                    </div>
                                </Link>
                            )}
                        </div>

                    </div>
                </div>
            )}
            <div className="mt-6 flex justify-end">
                <span className="text-xs text-zinc-500 font-inter">
                    v{APP_VERSION}
                </span>
            </div>
        </PageWithSidebar>

    );
}
